module.exports = __webpack_public_path__ + "assets/img/f425-kg.svg";